import { useState } from "react";
import { Upload, X } from "lucide-react";
import { api, errMsg, resolveImg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.url;
}

export function ImagePicker({ value, onChange, testId = "image-picker", label = "Bilgisayardan Yükle", compact = false }) {
  const [uploading, setUploading] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try { onChange(await uploadImage(file)); toast.success("Fotoğraf yüklendi"); } catch (err) { toast.error(errMsg(err)); } finally { setUploading(false); e.target.value = ""; }
  };
  return (
    <div className="flex flex-col sm:flex-row gap-3">
      <div className={`${compact ? "h-20 sm:w-32" : "h-28 sm:w-44"} w-full rounded-xl bg-slate-900 border border-slate-800 overflow-hidden shrink-0 relative`}>
        {value && <img src={resolveImg(value)} alt="" className="h-full w-full object-cover" />}
        {value && <button type="button" data-testid={`${testId}-clear`} onClick={() => onChange("")} className="absolute top-1 right-1 h-6 w-6 rounded-md bg-slate-950/80 text-slate-300 hover:text-red-300 flex items-center justify-center"><X className="h-3.5 w-3.5" /></button>}
      </div>
      <div className="flex-1 space-y-2">
        <label className="h-10 px-4 rounded-xl bg-slate-900 border border-slate-700 hover:border-cyan-500/50 text-sm text-slate-200 inline-flex items-center gap-2 cursor-pointer transition-colors">
          <Upload className="h-4 w-4 text-cyan-400" /> {uploading ? "Yükleniyor..." : label}
          <input data-testid={`${testId}-upload`} type="file" accept="image/*" className="hidden" onChange={pick} disabled={uploading} />
        </label>
        <Input data-testid={`${testId}-url`} className="cx-input" value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="veya görsel linki yapıştır" />
      </div>
    </div>
  );
}

export function MultiImagePicker({ values = [], onChange, testId = "multi-image" }) {
  const [uploading, setUploading] = useState(false);
  const pick = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    try {
      const urls = [];
      for (const f of files) urls.push(await uploadImage(f));
      onChange([...values, ...urls]);
      toast.success(`${urls.length} fotoğraf yüklendi`);
    } catch (err) { toast.error(errMsg(err)); } finally { setUploading(false); e.target.value = ""; }
  };
  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-2" data-testid={`${testId}-list`}>
        {values.map((u, i) => (
          <div key={i} className="relative h-20 w-28 rounded-lg overflow-hidden border border-slate-800 bg-slate-900">
            <img src={resolveImg(u)} alt="" className="h-full w-full object-cover" />
            <button type="button" data-testid={`${testId}-remove`} onClick={() => onChange(values.filter((_, j) => j !== i))} className="absolute top-1 right-1 h-6 w-6 rounded-md bg-slate-950/80 text-slate-300 hover:text-red-300 flex items-center justify-center"><X className="h-3.5 w-3.5" /></button>
          </div>
        ))}
      </div>
      <label className="h-10 px-4 rounded-xl bg-slate-900 border border-slate-700 hover:border-cyan-500/50 text-sm text-slate-200 inline-flex items-center gap-2 cursor-pointer transition-colors">
        <Upload className="h-4 w-4 text-cyan-400" /> {uploading ? "Yükleniyor..." : "Fotoğraf Ekle (çoklu)"}
        <input data-testid={`${testId}-upload`} type="file" accept="image/*" multiple className="hidden" onChange={pick} disabled={uploading} />
      </label>
    </div>
  );
}
